
import { useState, useEffect } from 'react';

import MainPlayerOverlays from '../../components/MainPlayerOverlays/MainPlayerOverlays';

import './Main.css';

export default function Main( props) {

  const calculateDimensions = () => ({ width: window.innerWidth, height: window.innerHeight });

  const [ dimensions, setDimensions ] = useState( calculateDimensions());

  useEffect( () => {
    const handler = () => setDimensions( calculateDimensions);
    window.addEventListener( 'resize', handler);
    return () => window.removeEventListener( 'resize', handler);
  }, []);

  if( props.custom_3_playerConfiguration?.customProps ) {
    props.custom_3_playerConfiguration.customProps.width = dimensions.width;
    props.custom_3_playerConfiguration.customProps.height = dimensions.height;
  }

  return (
    <div className='Main'>
      <div style={ dimensions } className='PlayerContainer'>
        { props.PlayerComponent.render( props) }
        <MainPlayerOverlays { ...props } />
      </div>
    </div>
  );
}
